import { render, staticRenderFns } from "./ck-editor-modal.html?vue&type=template&id=161ca6b9&scoped=true&"
import script from "./ck-editor-modal.js?vue&type=script&lang=js&"
export * from "./ck-editor-modal.js?vue&type=script&lang=js&"
import style0 from "./ck-editor-modal.scss?vue&type=style&index=0&id=161ca6b9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161ca6b9",
  null
  
)

export default component.exports